export default {"src":"/_next/static/media/yellow-dog.be67fc54.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};